import type { AnswerState } from '@repo/contracts/cardfinder/funnel/types';
import type { CardfinderSessionStatus } from '@/db/tables';
import { createServerSession, writeServerSession } from './sessionDAL';
import type { SessionSaveOutcome } from './sessionWriteResult';
import { markLocalSessionInProgress, readLocalSession, resetLocalSession } from './storage';

async function performSave(
  answers: AnswerState,
  status: CardfinderSessionStatus,
  funnelConfigVersion: string | undefined,
): Promise<SessionSaveOutcome> {
  const local = readLocalSession();

  if (local && local.kind !== 'recovered') {
    const result = await writeServerSession(local.id, answers, { status, funnelConfigVersion });

    if (result === 'not-found') {
      resetLocalSession();
      return performSave(answers, status, funnelConfigVersion);
    }
    return { result, sessionId: local.id };
  }

  const outcome = await createServerSession(answers, status, funnelConfigVersion);

  if (outcome.sessionId) markLocalSessionInProgress(outcome.sessionId);
  return outcome;
}

export function saveFunnelSession(
  answers: AnswerState,
  options?: { status?: CardfinderSessionStatus; funnelConfigVersion?: string },
): Promise<SessionSaveOutcome> {
  if (typeof window === 'undefined') return Promise.resolve({ result: 'ok', sessionId: null });

  return performSave(answers, options?.status ?? 'incomplete', options?.funnelConfigVersion);
}
